import { Quill } from 'react-quill'

const BlockEmbed = Quill.import('blots/block/embed')

class TicketAttachmentBlot extends BlockEmbed {
  static create(value) {
    const node = super.create()
    node.dataset.localId = value.localId
    node.dataset.kind = value.kind
    node.dataset.name = value.name
    node.dataset.mimeType = value.mimeType
    node.setAttribute('contenteditable', 'false')

    if (value.kind === 'image') {
      const image = document.createElement('img')
      image.src = value.previewUrl
      image.alt = value.name
      node.appendChild(image)
    } else if (value.kind === 'video') {
      const video = document.createElement('video')
      video.src = value.previewUrl
      video.controls = true
      video.preload = 'metadata'
      node.appendChild(video)
    } else {
      const link = document.createElement('a')
      link.href = value.previewUrl
      link.target = '_blank'
      link.rel = 'noopener noreferrer'
      link.textContent = value.linkText || value.name
      node.appendChild(link)
    }

    if (value.kind !== 'file') {
      const caption = document.createElement('figcaption')
      caption.textContent = value.name
      node.appendChild(caption)
    }

    return node
  }

  static value(node) {
    const media = node.querySelector('img, video, a')

    return {
      localId: node.dataset.localId ?? '',
      previewUrl: media?.getAttribute('src') ?? media?.getAttribute('href') ?? '',
      name: node.dataset.name ?? '',
      mimeType: node.dataset.mimeType ?? '',
      kind: node.dataset.kind ?? 'file',
      linkText: media?.textContent || undefined,
    }
  }
}

TicketAttachmentBlot.blotName = 'ticketAttachment'
TicketAttachmentBlot.tagName = 'figure'
TicketAttachmentBlot.className = 'ticket-inline-attachment'
Quill.register(TicketAttachmentBlot, true)
